import { render, staticRenderFns } from "./FourhandsReport.vue?vue&type=template&id=5487571f&scoped=true"
import script from "./FourhandsReport.vue?vue&type=script&lang=ts"
export * from "./FourhandsReport.vue?vue&type=script&lang=ts"
import style0 from "./FourhandsReport.vue?vue&type=style&index=0&id=5487571f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487571f",
  null
  
)

export default component.exports